import EquipmentListDrawer from './EquipmentsListDrawer'
import SectionsListDrawer from './SectionsListDrawer'
import SelectEquipmentDrawer from './SelectEquipmentDrawer'
import SectionInfoDrawer from './SectionInfoDrawer'
import DrawerHeader from './DrawerHeader'
import AssetsListDrawer from './AssetsListDrawer.vue'
import AutoIdentify from './AutoIdentify.vue'
import ProjectSetting from './ProjectSetting.vue'
import Layers from './Layers.vue'
import NoteSidebar from './NoteSidebar.vue'
export default {
    EquipmentListDrawer,
    SectionsListDrawer,
    SelectEquipmentDrawer,
    SectionInfoDrawer,
    DrawerHeader,
    AssetsListDrawer,
    AutoIdentify,
    ProjectSetting,
    Layers,
    NoteSidebar
}